export const GoogleTagManager = {

    requestDataAndPush: function() {
        $.ajax({
            url: '/?gtm',
            method: 'get',
            dataType: 'json'
        }).done(function (data) {
            if (typeof window.dataLayer === 'object') {
                if (typeof data.meineinkauf.data.user === 'object') {
                    Cookies.set('feUserData', data.meineinkauf.data.user);
                } else {
                    var userData = Cookies.getJSON('feUserData');
                    if (typeof userData === 'object') {
                        data['meineinkauf']['data']['user'] = userData;
                    }
                }
                window.dataLayer.push(data);
            }
        });
    }

};
